<template>
  <div class="filter-tree">
    <!-- <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText"
      size="small"
      suffix-icon="el-icon-search"
    /> -->
    <QueryVehOrGroup
      v-model="searchValue"
      style="margin: 5px"
    />
    <div class="filter-tree__content">
      <el-tree
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        @node-click="data => $emit('input', data)"
        :expand-on-click-node="false"
        node-key="organizationId"
        :filter-node-method="filterNode"
        highlight-current
        :default-expanded-keys="openKeys"
      >
        <span
          class="filter-tree__node"
          slot-scope="{ node, data }"
        >
          <i class="filter-tree__tree-icon iconfont icon-shebei" />
          <span>{{ data.organizationName }}</span>
          <span class="filter-tree__total">({{ data.sum }})</span>
          <span class="filter-tree__icon-box">
            <template v-if="USER.type === 1?true:false">
              <i
                class="filter-tree__icon iconfont"
                v-for="item in iconList"
                :key="item.value"
                :class="item.icon"
                :title="item.title"
                @click.stop="handleGroupClick(item.value, data)"
              />
            </template>

          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QueryVehOrGroup from "@/components/QueryVehOrGroup/index.vue";
// import { toTreeData } from "@/assets/js/base";

export default {
  components: {
    QueryVehOrGroup
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    selectPagger: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },

  data() {
    return {
      openKeys: [],
      searchValue: null,
      // filterText: "",
      defaultProps: {
        children: "children",
        label: "organizationName"
      },
      iconList: [
        { icon: "icon-Caraddinggroup", title: "添加组织", value: "onAddGroup" },
        {
          icon: "icon-Deletetrainset",
          title: "删除组织",
          value: "onDeleteGroup"
        },
        { icon: "icon-modify-", title: "修改组织", value: "onEditGroup" },
        { icon: "icon-Additionalcar", title: "添加设备", value: "addToGroup" }
      ]
    };
  },

  watch: {
    searchValue(val) {
      const { vehicleId } = val;
      vehicleId !== undefined && this.getMonitor(val);
      val.organizationId = val.organizationId || val.groupId;
      this.openKeys = [val.organizationId];
      //输入框搜索返回数据发送给当前filterTree的v-model
      this.$emit("input", val);
      const { scrollToTreeHighLight } = this;
      scrollToTreeHighLight(val.organizationId);
    }
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // }
  },

  computed: {
    ...mapState(["GROUPLIST", "USER"]),
    treeData() {
      return this.treeFormat(this.GROUPLIST);
      // return toTreeData(this.GROUPLIST, {
      //   id: "organizationId",
      //   parentId: "parentId"
      // });
    }
  },

  methods: {
    treeFormat(data) {
      for (let item of data) {
        item.children = item.organizationsList;
        if (item.organizationsList && item.organizationsList.length > 0) {
          this.treeFormat(item.organizationsList);
        }
      }
      return data;
    },
    //获取查询数据所在页数
    async getMonitor(val) {
      const { vehicleId } = val;
      const organizationId = val.organizationId || val.groupId;
      try {
        const pagger = (await this.$API.getMonitor({
          organizationId,
          vehicleId,
          total: this.pageSize
        }))["data"];
        // this.selectPagger = pagger.pagger;
        this.$emit("update:selectPagger", pagger.pagger);
      } catch (error) {
        console.log(error);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return (
        data.organizationName
          .toLocaleLowerCase()
          .indexOf(value.toLocaleLowerCase()) !== -1
      );
    },
    handleGroupClick(type, data) {
      switch (type) {
        case "onAddGroup":
          this.$emit("onAddGroup", { ...data, userId: this.USER.userId });
          break;
        case "onDeleteGroup":
          this.$emit("onDeleteGroup", {
            organizationId: String(data.organizationId)
          });
          break;
        case "onEditGroup":
          this.$emit("onEditGroup", data);
          break;
        case "addToGroup":
          this.$emit("onHandleVeh", "add", data);
          break;
      }
    },
    //滚动到树状图当前高亮节点
    async scrollToTreeHighLight(organizationId) {
      //css 选中
      this.$refs.tree.setCurrentKey(organizationId);
      await this.$nextTick();
      await this.$sleep(100);
      const activeDom = this.$refs.tree.$el.getElementsByClassName(
        "is-current"
      )[0];
      activeDom && activeDom.scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-tree {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__content {
    margin-top: 16px;
    flex: 1;
    overflow-y: auto;
    @include scrollBar;
  }

  &__node {
    display: flex;
    align-items: center;
  }

  &__total {
    color: currentColor;
    margin-left: 5px;
  }

  &__tree-icon {
    margin-right: 5px;
    font-size: 14px;
    color: #18c18b;
  }

  &__icon-box {
    display: none;
  }

  &__icon {
    margin-left: 10px;
    color: #cfcfcf;
    font-size: 14px;

    & + & {
      margin-left: 5px;
    }

    &:hover {
      color: #18c18b;
    }
  }
}

.el-tree-node__content {
  &:hover {
    .filter-tree__icon-box {
      display: block;
    }
  }
}
</style>
